// extracted by mini-css-extract-plugin
export default {"container":"Dropzone_container__1LODR","dropzone":"Dropzone_dropzone__VDRbk","disabled":"Dropzone_disabled__YhC4G","center":"Dropzone_center__GY6uk"};